export default __webpack_public_path__ + "static/media/confirmBudget.71d68808.svg";